'use client';

import React from 'react';
import { Section, Container } from '@layout';
import { Card, DateInputPopover, Heading } from '@ui';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface DateInputPopoverDemoProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  value?: string; // YYYY-MM-DD controlled
  onChange?: (isoDate: string | '') => void;
  isSpanish?: boolean;
}

const DateInputPopoverDemo: React.FC<DateInputPopoverDemoProps> = ({
  isSpanish = false,
  sectionID = '',
  classes = '',
  containerId,
  containerClasses,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section sectionID={sectionID} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as='h3'>{t('Date Input (Popover)', 'Entrada de fecha (Popover)')}</Heading>
        <p className='sub'>
          {t(
            'Calendar opens on input/focus; ESC/outside to dismiss.',
            'El calendario se abre al escribir o enfocar; ESC o fuera para cerrar.'
          )}
        </p>
        <Card>
          <DateInputPopover id='dateInput1' />
        </Card>
      <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<label for="date-popover">Date</label>
<input id="date-popover" type="text" placeholder="YYYY-MM-DD" />`}
        />
      </Container>
    </Section>
  );
};

export default DateInputPopoverDemo;
